import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FieldService} from './field.service';
import {FieldTableDto} from '@tj/tj-dmp-lib-api';
import {AbstractEditorComponent} from '../field-editor/abstract-editor.component';
import {v4 as uuidv4} from 'uuid';
import { DynamicDisplayDirective } from '../field-display/dynamic-display.directive';
import { DynamicEditorDirective } from '../field-editor/dynamic-editor.directive';
@Component({
    selector: 'dmp-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
    standalone: false
})
export class FieldComponent implements OnInit, OnChanges, OnDestroy {

    @Input() subQuery: string = null;
    @Input() indexSubQuery = 0;
    @Input() table: string;
    @Input() field: string;
    @Input() readonly = false;
    @Output() valueChange = new EventEmitter<any>();

    editor: AbstractEditorComponent;
    fiedTable: FieldTableDto = null;

    private _value: any;
    
    @Input() 
    set value(val: any) {
        if(this._value === val){
            return;
        }
        this._value = val;
        if (this.dynamicDisplayDirective) {
            this.dynamicDisplayDirective.value = val;
            this.dynamicDisplayDirective.update();
        }
        if (this.dynamicEditorDirective) {
            this.dynamicEditorDirective.value = val;
            this.dynamicEditorDirective.update();
        }
    }
    
    get value(): any {
        return this._value;
    }

    @ViewChild(DynamicDisplayDirective) dynamicDisplayDirective: DynamicDisplayDirective;
    @ViewChild(DynamicEditorDirective) dynamicEditorDirective: DynamicEditorDirective;

    // pour identifier l'instance du field
    public uuid = uuidv4();
    fieldDataNotFound = false;

    constructor(public fieldService: FieldService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.fieldService.addField(this);
    }

    ngOnDestroy(): void {
        this.fieldService.removeFieldByUuid(this.uuid);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.loadData();
    }

    ngOnInit(): void {
        this.loadData();
    }

    public loadData() {
        if (!this.fieldService.tables) {
            return;
        }
        const table = this.fieldService.tables.find(t => t.code === this.table);
        if (table) {
            this.fiedTable = table.fields.find(f => f.code === this.field) as FieldTableDto;
            this.fiedTable.table = this.table;
        }
    
        const key = `${this.table}.${this.field}`;
        if (this.subQuery === null) {
            this.value = this.fieldService.data.mainData.rows[key];
        } else {
          const dataSubQuery = this.fieldService.data.dataSubQuery[this.subQuery];
          if (dataSubQuery == null) { return; }
          const row = dataSubQuery.content[this.indexSubQuery];
          if (row == null) { return; }
          this.value = row.rows[key];
        }
    
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }

    getValueWithException(): string {
        if (this.fieldService.mode === 'EDIT') {
            return this.editor.getValueWithException() as unknown as string;
        } else {
            throw new Error('read mode');
        }
    }

    getKey() {
        return `${this.fiedTable.table}.${this.fiedTable.code}`;
    }

    getTable(): string {
        return this.fiedTable.table;
    }

    isValid() {
        if (this.fieldService.mode === 'EDIT') {
            return this.editor.isValid();
        } else {
            throw new Error('read mode');
        }
    }

    isDirty() {
        if (this.fieldService.mode === 'EDIT') {
            return this.editor?.isDirty();
        } else {
            throw new Error('read mode');
        }
    }

    onInitEditor($event: AbstractEditorComponent) {
        this.editor = $event;
    }

    commit() {
        this.editor.save();
    }

    onDataNotFound($event: FieldTableDto) {
        this.fieldDataNotFound = true;
    }
}
